/*       */

import React from 'react';

import Help from 'app/utils/designer/form/settings/common/Help';
import { name, label } from 'app/utils/designer/form/settings/common/commonBase';
import { onLoad, onChange, isVisible, isDisabled } from 'app/utils/designer/form/settings/common/commonEvents';
import { help } from 'app/utils/designer/form/settings/common/commonHelpers';
import { required } from 'app/utils/designer/form/settings/common/commonValidation';
import { flexGrow } from 'app/utils/designer/form/settings/common/commonStyles';

const panels = [
    {
        header: 'Base',
        children: [
            name,
            label,
            {
                type: 'text',
                properties: {
                    label: 'Remote Point Ref',
                    name: 'properties.remoteRef',
                    help: <Help message="Reference to the remote entity or process data" />,
                },
            },
        ],
    },
    {
        header: 'Events',
        children: [onLoad, onChange, isVisible, isDisabled],
    },
    {
        header: 'Validation',
        children: [required],
    },
    {
        header: 'Styles',
        children: [flexGrow],
    },
    {
        header: 'Helpers',
        children: [help],
    },
];

export default {
    defaults: { serialize: true },
    panels: settingValues => panels,
};
